import type React from 'react';

import { Button, Image, Text } from '@change/ds-core-ui';

import { useGetStaticAssetUrl } from '@change-corgi/core-react/assets';
import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import type { LandingPageSlug } from '#src/app/pages/landing/template/pageContext';

type Props = {
	slug: LandingPageSlug;
	onCtaClick: () => void;
};

export const FooterCta: React.FC<Props> = ({ onCtaClick, slug }) => {
	const { translate } = useI18n();
	const getStaticAssetUrl = useGetStaticAssetUrl();

	return (
		<div className="p-10">
			<div className="block md:hidden">
				<Image
					className="aspect-auto py-8"
					alt=""
					src={getStaticAssetUrl(translate(`landing.${slug}.assets.faces_mobile`))}
				/>
			</div>
			<div className="my-8 flex items-center justify-center">
				<div className="hidden md:inline">
					<Image
						className="aspect-auto max-w-[300px] p-4"
						alt=""
						src={getStaticAssetUrl(translate(`landing.${slug}.assets.faces_left`))}
					/>
				</div>
				<div className="flex-1 px-0 md:px-4">
					<Text as="p" size="x-large" fontWeight="bold" className="text-typography-brand mb-4 text-center">
						<Translate value={`landing.${slug}.footer_cta.title`} />
					</Text>
					<Text as="p" className="text-center">
						<Translate value={`landing.${slug}.footer_cta.body`} />
					</Text>
					<div className="mt-8 flex items-center justify-center">
						<Button
							as="a"
							href={`/start-a-petition/intro?source_location=${slug}_landing_page`}
							onClick={onCtaClick}
							variant="primary"
							className="w-[300px]"
						>
							<Translate value={`landing.${slug}.footer_cta.button`} />
						</Button>
					</div>
				</div>
				<div className="hidden md:inline">
					<Image
						className="aspect-auto max-w-[300px] p-4"
						alt=""
						src={getStaticAssetUrl(translate(`landing.${slug}.assets.faces_right`))}
					/>
				</div>
			</div>
		</div>
	);
};
